import { useEffect, useState } from "react";
import { useAppSelector } from "../../redux/hooks";
import { Helmet } from "react-helmet";

const HeaderConfig: React.FC = () => {
  const { tenancyConfigData } = useAppSelector((state) => ({
    tenancyConfigData: state.affiliate.multiTenancyConfigData,
  }));
  const [logoImage, setLogoImage] = useState<string>("");

  useEffect(() => {
    if (tenancyConfigData?.affiliateFavicon || tenancyConfigData?.favIcon) {
      // Update favicon
      setLogoImage(
        tenancyConfigData.affiliateFavicon
          ? tenancyConfigData.affiliateFavicon
          : `data:image/png;base64,${tenancyConfigData.favIcon}`,
      );
    } else {
      // Fallback to default favicon
      setLogoImage("/favicon.ico");
    }
  }, [tenancyConfigData?.affiliateFavicon, tenancyConfigData?.favIcon]);

  return (
    <Helmet>
      <title>{tenancyConfigData?.affiliateName || "Mito Money"}</title>
      <link rel="icon" href={logoImage} />
      <link rel="apple-touch-icon" href={logoImage} />
    </Helmet>
  );
};

export default HeaderConfig;
